// Generated by scripts/generate-english-catalog.mjs; product terminology may be overridden in i18n.tsx.
export const generatedEnglishCatalog: Record<string, string> = {
  "；关闭后无法再次查看。": "; Cannot be viewed again after closing.",
  "·": "·",
  "到期": "maturity",
  "· 创建于": "· Created in",
  "· 第": "· No.",
  "（请求编号：": "(Request number:",
  "1 小时": "1 hour",
  "24 小时": "24 hours",
  "30 天": "30 days",
  "6 位动态验证码": "6-digit dynamic verification code",
  "7 天": "7 days",
  "安全会话有效": "Secure session valid",
  "安全入口已启用": "Security portal is enabled",
  "安全退出": "safe exit",
  "安全验证加载失败，请检查网络后重试。": "Security verification failed to load, please check the network and try again.",
  "安装路径": "Installation path",
  "版本": "Version",
  "版本将从活跃发布流程中隐藏，但版本元数据、签名结果和审计历史都会保留。归档后不可恢复。": "The version will be hidden from the active release process, but version metadata, signing results, and audit history will be retained. Once archived it cannot be restored.",
  "版本将进入公开更新目录，影响": "The version will enter the public update directory, affecting",
  "版本将退出公开更新目录，客户端会回退选择该渠道中仍为 PUBLISHED 的上一版本。审计历史不会删除。": "The version will exit the public update catalog and the client will fallback to the previous version in the channel that was still PUBLISHED. Audit history will not be deleted.",
  "版本信息": "Version information",
  "版本已归档，元数据和审计历史仍完整保留。": "Versions are archived and metadata and audit history remain intact.",
  "版本已回滚，后续更新检查将不再选择它。": "The version has been rolled back and subsequent update checks will no longer select it.",
  "版本已正式发布并进入公开更新目录。": "The version has been officially released and entered the public update directory.",
  "保存变更": "Save changes",
  "保存后，所有拥有该角色的管理员会在下一次会话校验时使用新权限。": "After saving, all administrators with this role will use the new permissions during the next session verification.",
  "保存系统设置": "Save system settings",
  "保存修改": "Save changes",
  "本次验证请求将在": "This verification request will be",
  "编辑": "edit",
  "编辑管理员 ·": "Editorial Administrator ·",
  "编辑角色 ·": "Edit role ·",
  "编辑权限": "Edit permissions",
  "标记风险事件已处理": "Mark the risk event as handled",
  "标记已处理": "Flag processed",
  "不能超过 500 个字符。": "Cannot exceed 500 characters.",
  "不能低于已使用次数。": "Cannot be less than the number of times used.",
  "参与者": "participants",
  "操作": "operate",
  "操作，例如 PLAYER_UPDATED": "Operations, such as PLAYER_UPDATED",
  "操作审计": "Operational audit",
  "操作失败。": "The operation failed.",
  "操作原因": "Reason for operation",
  "操作原因不能超过 500 个字符。": "The reason for the action cannot exceed 500 characters.",
  "策略": "Strategy",
  "查看 Fleet 容量、心跳与证书状态。节点 Token、证书私钥和 Allocation Token 不返回浏览器。": "View Fleet capacity, heartbeat, and certificate status. Node Token, certificate private key, and Allocation Token are not returned to the browser.",
  "查看房间状态、容量和心跳；关闭操作会同时触发连接与 Relay 清理。": "Check the room status, capacity and heartbeat; closing operation will trigger connection and Relay cleanup at the same time.",
  "查看连接状态与网络路径。候选地址、Relay Token 和加密材料不会返回管理浏览器。": "View connection status and network path. Candidate addresses, Relay Tokens, and cryptographic materials are not returned to the management browser.",
  "查看权限明细": "View permission details",
  "查看邀请码批次、使用情况与有效期": "Check the invitation code batch, usage and validity period",
  "查看异常认证事件及关联请求": "View abnormal authentication events and related requests",
  "查询玩家、变更账号状态、撤销登录会话": "Query players, change account status, and cancel login sessions",
  "查询玩家认证状态与账号属性。完整 IP 和凭据不会在列表中展示。": "Query player authentication status and account attributes. The full IP and credentials will not be displayed in the list.",
  "撤销": "Cancel",
  "撤销该管理员会话？": "Revoke this administrator session?",
  "撤销该玩家的全部会话？": "Undo all sessions for this player?",
  "撤销节点": "Undo node",
  "撤销全部会话": "Cancel all sessions",
  "撤销失败。": "Undo failed.",
  "撤销是永久操作；该邀请码之后不能再次启用。": "Revoking is a permanent operation; the invitation code cannot be activated again later.",
  "撤销原因": "Reason for withdrawal",
  "成功": "success",
  "成员": "member",
  "成员已移出，但 Connection 清理尚未完全确认，请按 Runbook 复核。": "The member has been moved out, but the Connection cleanup has not been fully confirmed, please press the runbook to review.",
  "成员已移出房间，关联 Connection 已关闭。": "The member has moved out of the room and the associated Connection has been closed.",
  "成员状态将变为 LEFT，其关联 Connection 与 Relay Allocation 会被清理。房主不能单独踢出；如需处理房主请关闭房间。": "The member status will change to LEFT, and its associated Connection and Relay Allocation will be cleared. The host cannot be kicked out alone; if you need to deal with the host, please close the room.",
  "初始密码": "Initial password",
  "处理结论不能超过 500 个字符。": "The processing conclusion cannot exceed 500 characters.",
  "处理结论与原因": "Processing conclusions and reasons",
  "处理失败。": "Processing failed.",
  "处理状态": "Processing status",
  "创建": "create",
  "创建 DRAFT": "Create DRAFT",
  "创建并生成 MFA": "Create and generate MFA",
  "创建房间": "Create room",
  "创建后仍不会立即发布": "Will not be published immediately after creation",
  "创建时间": "creation time",
  "创建邀请码": "Create invitation code",
  "创建邀请码批次": "Create invitation code batch",
  "创建原因": "Reason for creation",
  "创建账号": "Create account",
  "创建者": "Creator",
  "此入口不接受玩家 Access Token 或机器运维 Token": "This entrance does not accept player Access Token or machine operation and maintenance Token",
  "次 ·": "Second-rate ·",
  "错误码": "error code",
  "打开 Grafana": "Open Grafana",
  "打开 Runbook": "Open a runbook",
  "大小": "size",
  "大小（字节）": "Size (bytes)",
  "待处理": "Pending",
  "待处理风险事件": "Pending risk events",
  "当前管理 API 不接收任意二进制上传；请填写受控 CDN 下的 Object Key、真实大小与 SHA-256。校验会从服务端对每个对象执行 HEAD 可用性探测，失败时不能发布。": "The current management API does not accept arbitrary binary uploads; please fill in the Object Key, true size and SHA-256 under the controlled CDN. The verification will perform HEAD availability detection on each object from the server side, and cannot be published if it fails.",
  "当前管理员 TOTP 或恢复码": "Current administrator TOTP or recovery code",
  "当前管理员角色缺少此操作权限。": "The current administrator role lacks this operation permission.",
  "当前会话": "current session",
  "当前结果": "Current results",
  "当前路径": "current path",
  "当前没有 P2P 房间。": "There are currently no P2P rooms.",
  "当前没有登录风险事件。": "There are currently no login risk events.",
  "当前没有管理员登录审计记录。": "There are currently no administrator login audit records.",
  "当前没有可显示的操作审计记录。": "There are currently no operational audit records to display.",
  "当前没有已注册的 Dedicated Server。": "There are currently no Dedicated Servers registered.",
  "当前没有已注册的中继节点。": "There are currently no registered relay nodes.",
  "当前异常": "current exception",
  "当前在线玩家": "Current online players",
  "当前状态下没有玩家。": "There are no players in the current state.",
  "导出当前结果": "Export current results",
  "的 Relay？": "Relay?",
  "登录安全验证": "Login security verification",
  "登录次数": "Number of logins",
  "登录风险": "Login risk",
  "登录风险事件": "Login risk events",
  "登录管理控制台": "Log in to the management console",
  "登录历史 (": "Login history (",
  "登录名": "Login name",
  "登录审计": "Login audit",
  "登录失败，请稍后重试。": "Login failed, please try again later.",
  "登录事件": "Login event",
  "第二步，共两步": "The second step, two steps in total",
  "第一步，共两步": "The first step, two steps in total",
  "动态验证码": "Dynamic verification code",
  "动态验证码或恢复码": "Dynamic verification code or recovery code",
  "都有身份、有边界、有记录": "They all have identities, boundaries, and records",
  "独立认证": "Independent certification",
  "短期 Access Token · HttpOnly Refresh Cookie": "Short-term Access Token · HttpOnly Refresh Cookie",
  "短期凭据": "short-term credentials",
  "二次 MFA 校验失败。": "Secondary MFA verification failed.",
  "二次校验结果仅在内存中保存数分钟，并绑定当前管理员 Session。": "The secondary verification results are only saved in memory for a few minutes and bound to the current administrator session.",
  "发布": "release",
  "发布操作": "publish operation",
  "发布前检查": "Check before publishing",
  "发布前校验通过，版本已进入 READY。": "The pre-release verification has passed and the version has entered READY.",
  "发布时间": "Release time",
  "发布详情 ·": "Release details ·",
  "反自动化": "Anti-automation",
  "返回列表": "Return to list",
  "返回玩家列表": "Return to player list",
  "返回账号验证": "Return to account verification",
  "范围": "scope",
  "房间": "Room",
  "房间 ID": "Room ID",
  "房间、专服、中继节点与活动连接": "Rooms, dedicated servers, relay nodes and active connections",
  "房间成员 ·": "Room members ·",
  "房间及其活动连接已关闭。": "The room and its active connections are closed.",
  "房间将进入 CLOSED，所有成员离开，活动连接和 Relay Allocation 会被清理。此操作不能从页面撤销。": "The room will enter CLOSED, all members will leave, and active connections and Relay Allocation will be cleared. This action cannot be undone from the page.",
  "房间已关闭，但连接清理尚未完全确认，请按 Runbook 复核。": "The room has been closed but the connection cleanup has not been fully confirmed, please press the runbook to review.",
  "风险事件": "risk event",
  "风险事件 (": "risk event (",
  "风险事件已标记为处理完成。": "The risk event is marked for processing.",
  "封禁该玩家？": "Ban this player?",
  "封禁玩家": "ban player",
  "否": "no",
  "服务端 RBAC + 审计": "Server-side RBAC + auditing",
  "服务器返回了无法识别的响应。": "The server returned an unrecognized response.",
  "复制": "copy",
  "复制全部": "copy all",
  "复制完整配置": "Copy complete configuration",
  "该设备将无法继续刷新管理员凭据。": "The device will no longer be able to refresh administrator credentials.",
  "该玩家可能不存在，或当前管理员没有查看权限。": "The player may not exist, or the current administrator may not have permission to view it.",
  "该玩家没有关联风险事件。": "There are no risk events associated with this player.",
  "该玩家没有可显示的 Session。": "This player has no sessions to display.",
  "该玩家没有可显示的登录历史。": "This player has no login history to display.",
  "该资源不支持直接删除。": "This resource does not support direct deletion.",
  "更新时间": "Update time",
  "更新于": "updated on",
  "工作台": "workbench",
  "功能开关": "Function switch",
  "关闭": "closure",
  "关闭房间": "close room",
  "关闭后无法从服务器恢复。请立即复制或下载，并将文件存放在受控位置。": "Unable to restore from server after shutdown. Please copy or download now and keep the file in a controlled location.",
  "管理操作": "Management operations",
  "管理控制台": "Management console",
  "管理模块": "Management module",
  "管理入口安全说明": "Management entrance security instructions",
  "管理入口已经与玩家认证分离。当前控制台只展示控制面明确授权的数据与操作，不直接连接数据库或中继节点。": "The management portal has been separated from player authentication. The current console only displays data and operations explicitly authorized by the control plane and does not directly connect to the database or relay nodes.",
  "管理员": "administrator",
  "管理员 ID": "Administrator ID",
  "管理员登录尚未启用": "Administrator login is not enabled yet",
  "管理员登录审计": "Administrator login audit",
  "管理员会话已撤销。": "Administrator session revoked.",
  "管理员认证与玩家系统完全隔离。登录需要通过浏览器反自动化校验、账号密码和动态验证码，写操作由控制面统一授权并记录审计。": "Administrator authentication is completely isolated from player systems. Login requires browser anti-automatic verification, account password and dynamic verification code. Write operations are authorized by the control plane and recorded for audit.",
  "管理员身份与玩家账号隔离；高风险变更要求权限、操作原因和短时 MFA 提权。": "Administrator identities are isolated from player accounts; high-risk changes require permissions, operational reasons, and short-term MFA privilege escalation.",
  "管理员已创建。请立即交付一次性 MFA 配置。": "Administrator has been created. Please deliver the one-time MFA configuration immediately.",
  "管理员账号": "Administrator account",
  "管理员账号、会话、密钥和权限表均与玩家系统隔离。": "Administrator accounts, sessions, keys, and permission tables are isolated from player systems.",
  "管理员治理请求失败。": "Admin governance request failed.",
  "管理员资料和权限分配已更新。": "Administrator profiles and permission assignments have been updated.",
  "归档": "Archive",
  "后端会从合格的 READY 节点中自动选择目标；页面不接受任意 IP 或节点地址。迁移期间连接状态会变为 MIGRATING_RELAY。": "The backend automatically selects targets from eligible READY nodes; the page does not accept arbitrary IP or node addresses. The connection status changes to MIGRATING_RELAY during migration.",
  "后端审计": "Backend audit",
  "恢复": "recover",
  "恢复该玩家账号？": "Restore this player's account?",
  "恢复接入": "Restore access",
  "恢复节点": "Recovery node",
  "恢复码（每个仅可使用一次）：": "Recovery codes (can only be used once each):",
  "恢复为正常": "return to normal",
  "回滚": "rollback",
  "活动 P2P 房间": "Event P2P Room",
  "活动连接": "active connection",
  "活动中继分配": "Active relay assignment",
  "记录复核人、工单或补充背景；请勿填写密码、Token 或隐私数据": "Record the reviewer, work order or supplementary background; do not fill in password, token or private data",
  "记录后端实际执行的写操作、原因、请求编号和字段差异。凭据类字段在返回前自动脱敏。": "Document the actual write operations performed by the backend, the reason, request number, and field differences. Credential class fields are automatically desensitized before being returned.",
  "技术详情": "Technical details",
  "继续验证": "Continue to verify",
  "加入时间": "Join time",
  "架构": "Architecture",
  "将": "Will",
  "将该玩家设为 VIP？": "Make this player a VIP?",
  "将更新": "will be updated",
  "将重新生成并验证 Manifest、文件元数据、CDN 对象可访问性、兼容版本及 Ed25519 签名。": "The manifest, file metadata, CDN object accessibility, compatible versions, and Ed25519 signatures will be regenerated and verified.",
  "角色": "Role",
  "角色权限集已原子更新。": "Role permission sets have been updated atomically.",
  "角色权限请求失败。": "Role permission request failed.",
  "角色与权限": "Roles and permissions",
  "接收任务？": "Accept a mission?",
  "节点将恢复为 READY 并重新接收连接。": "The node will revert to READY and resume accepting connections.",
  "节点将停止新分配、断开控制通道，并迁移或中断现有连接；重新恢复必须重新注册。": "The node will stop new allocations, disconnect control channels, and migrate or break existing connections; it must re-register to resume.",
  "节点将停止新分配；可选择迁移现有连接，并设置维护期限。": "Nodes will stop new allocations; existing connections can optionally be migrated, and maintenance periods set.",
  "结果": "result",
  "仅显示 Turnstile 校验结论和诊断字段；不会保存 Widget Token、Secret、密码或 Cookie。": "Only Turnstile verification results and diagnostic fields are displayed; Widget Tokens, Secrets, passwords, or cookies are not saved.",
  "仅允许 HTTPS URL。": "Only HTTPS URLs are allowed.",
  "进入维护": "Enter maintenance",
  "进入维护模式？": "Entering maintenance mode?",
  "开关用于能力发现和未来模块显隐；未实现的领域服务不会因前端开关而被绕过。": "Switches are used for capability discovery and future module visibility; unimplemented domain services will not be bypassed by front-end switches.",
  "开始校验": "Start verification",
  "可信网段与反向代理边界": "Trusted network segment and reverse proxy boundary",
  "可信网络": "trusted network",
  "可选更新": "Optional updates",
  "客户端发布": "Client publishing",
  "控制面缺少 Turnstile Sitekey 或 Secret。配置完成前登录会失败关闭。": "The control plane is missing a Turnstile Sitekey or Secret. Login will fail and close before configuration is completed.",
  "来源地址": "Source address",
  "立即撤销该管理员的全部现有会话": "Immediately revoke all existing sessions for this administrator",
  "立即撤销该玩家的全部会话，使现有 Token 失效": "Immediately revoke all sessions of this player and invalidate existing tokens",
  "例如：2026 夏季测试资格": "Example: 2026 Summer Test Eligibility",
  "例如：发布工单 REL-2026-071，Windows stable 1.4.0": "For example: Release ticket REL-2026-071, Windows stable 1.4.0",
  "例如：客服工单 CS-4812 已确认账号违规": "For example: Customer service ticket CS-4812 Account violation confirmed",
  "例如：值班工单 OPS-4812，节点心跳异常需要进入维护": "For example: duty work order OPS-4812, the node heartbeat is abnormal and needs to be maintained.",
  "联机资源": "Online resources",
  "浏览器未允许访问剪贴板，请逐条复制或下载 CSV。": "Your browser does not allow access to the clipboard. Please copy or download the CSV item by item.",
  "路径": "path",
  "轮询回退": "Polling fallback",
  "没有符合条件的 Connection。": "There are no matching Connections.",
  "没有可用的管理员会话。": "No administrator session available.",
  "没有需要保存的设置变更。": "There are no settings changes to save.",
  "每码最大使用次数": "Maximum number of uses per code",
  "密码": "password",
  "密码 + TOTP / 恢复码": "Password + TOTP / recovery code",
  "密码、TOTP 与恢复码": "Passwords, TOTP and recovery codes",
  "密码只用于本次创建；TOTP URI 和恢复码将在成功后显示一次。": "The password is only used for this creation; the TOTP URI and recovery code will be displayed once upon success.",
  "秒": "Second",
  "明文邀请码只在创建成功时显示一次；后端仅保存不可逆哈希。": "The plain text invitation code is only displayed once when the creation is successful; the backend only saves the irreversible hash.",
  "模式": "model",
  "模型已预留": "Model has been reserved",
  "默认": "default",
  "目标": "Target",
  "目标 ID": "Target ID",
  "内部备注（可选）": "Internal notes (optional)",
  "内部备注不能超过 2000 个字符。": "Internal comments cannot exceed 2000 characters.",
  "批次": "batch",
  "批次名称": "Batch name",
  "平台": "platform",
  "普通列表轮询": "Normal list polling",
  "启用": "enable",
  "启用后，该邀请码将在配额和有效期允许时立即可用。": "Once enabled, the invitation code will be available as soon as quota and validity allow.",
  "迁移": "migrate",
  "迁移 Relay": "Migration Relay",
  "迁移现有连接到其他 READY 节点": "Migrate existing connections to other READY nodes",
  "迁移已开始：": "Migration has started:",
  "签名 Key": "Signature Key",
  "强身份": "strong identity",
  "强制更新": "Force update",
  "强制旧版本更新（发布时最低兼容版本将提升到本版本）": "Force old versions to be updated (the minimum compatible version will be upgraded to this version when released)",
  "请立即交付给": "Please deliver immediately to",
  "请求编号": "Request number",
  "请求失败，请稍后重试。": "The request failed, please try again later.",
  "请求失败。": "The request failed.",
  "请稍后刷新；若持续失败，请将页面中的请求编号提供给平台值班人员。": "Please refresh later; if it continues to fail, please provide the request number on the page to the platform personnel on duty.",
  "请使用管理员登录页面完成 Turnstile、密码和 MFA 校验。": "Please use the admin login page to complete Turnstile, password, and MFA verification.",
  "请输入 64 位小写十六进制 SHA-256。": "Please enter 64-bit lowercase hexadecimal SHA-256.",
  "请输入当前 TOTP 或一次性恢复码。": "Please enter your current TOTP or one-time recovery code.",
  "请输入管理员账号。": "Please enter the administrator account.",
  "请输入密码。": "Please enter your password.",
  "请输入完整的 HTTPS URL。": "Please enter the complete HTTPS URL.",
  "请输入验证码或恢复码。": "Please enter the verification code or recovery code.",
  "请输入至少 12 个字符的初始密码。": "Please enter an initial password of at least 12 characters.",
  "请填写处理结论。": "Please fill in the processing conclusion.",
  "请填写发布工单或变更原因。": "Please fill in the reason for posting the work order or change.",
  "请填写可供审计追溯的操作原因。": "Please fill in the reasons for the operation that can be audited and traced.",
  "请先完成安全验证。": "Please complete the security verification first.",
  "区域": "area",
  "趋势，共": "trend, total",
  "渠道": "channel",
  "取消": "Cancel",
  "取消 VIP": "Cancel VIP",
  "取消该玩家的 VIP？": "Cancel this player's VIP?",
  "全部状态": "All status",
  "权限": "Permissions",
  "权限范围": "Scope of authority",
  "权限由后端目录统一定义；角色变更会被记录到审计日志，并要求当前管理员再次完成 MFA。": "Permissions are defined uniformly by the backend directory; role changes will be recorded in the audit log and require the current administrator to complete MFA again.",
  "确认": "confirm",
  "确认保存": "Confirm to save",
  "确认撤销": "Confirm revocation",
  "确认撤销节点": "Confirm revoke node",
  "确认处理": "Confirm processing",
  "确认更新": "Confirm update",
  "确认关闭": "Confirm close",
  "确认关闭房间": "Confirm to close the room",
  "确认管理操作": "Confirm management action",
  "确认归档": "Confirm archiving",
  "确认恢复": "Confirm recovery",
  "确认回滚": "Confirm rollback",
  "确认进入维护": "Confirm to enter maintenance",
  "确认开始迁移": "Confirm to start migration",
  "确认踢出成员": "Confirm to kick member",
  "确认替换权限集": "Confirm replacement permission set",
  "确认停用": "Confirm deactivation",
  "确认永久撤销": "Confirm permanent revocation",
  "确认正式发布": "Confirm official release",
  "确认执行": "Confirm execution",
  "确认专服操作": "Confirm dedicated server operation",
  "让": "let",
  "让每一次管理操作": "Make every management operation",
  "人数": "Number of people",
  "认证": "Certification",
  "认证等级": "Certification level",
  "认证活动与风险": "Certification activities and risks",
  "认证提供方": "Certification provider",
  "任意一层失败都会阻止登录或越权操作": "Failure at any level will prevent login or unauthorized operations",
  "入口安全链": "Entrance security chain",
  "筛选": "filter",
  "上一步": "Previous step",
  "尚未登录": "Not logged in yet",
  "尚未记录": "Not recorded yet",
  "尚未配置 Grafana": "Grafana has not been configured yet",
  "尚未配置 Runbook": "Runbook not configured yet",
  "尚未生成": "Not yet generated",
  "尚未执行校验。": "Verification has not been performed yet.",
  "尚无管理侧客户端发布。": "No management-side client has been released yet.",
  "尚无玩家记录。": "There are no player records yet.",
  "尚无邀请码。": "No invitation code yet.",
  "设备哈希不返回前端，IP 地址由控制面脱敏。技术详情按需展开。": "Device hashes are not returned to the frontend and IP addresses are desensitized by the control plane. Technical details are expanded as needed.",
  "设备摘要": "Device Summary",
  "设为 VIP": "Set as VIP",
  "身份验证完成。": "Authentication completed.",
  "生成数量": "Generate quantity",
  "生成邀请码": "Generate invitation code",
  "失败": "fail",
  "失败原因": "Reason for failure",
  "失效。": "Invalid.",
  "时间": "time",
  "实时订阅": "Live subscription",
  "实现边界": "Realize boundaries",
  "使用独立管理员账号登录。连续失败会触发账号和来源地址限流。": "Log in using a separate administrator account. Continuous failures will trigger account and source address current limiting.",
  "使用记录": "Usage records",
  "使用记录 ·": "Usage records ·",
  "使用量": "Usage",
  "使用时间": "usage time",
  "事件": "event",
  "是": "yes",
  "收起导航": "Collapse navigation",
  "受保护的运营入口": "Protected operational entrance",
  "输入管理员密码": "Enter administrator password",
  "输入认证器中的六位验证码，或使用一枚未使用的恢复码。": "Enter the six-digit verification code from your authenticator, or use an unused recovery code.",
  "刷新": "refresh",
  "双人审批": "Double approval",
  "四层校验生效": "Four levels of verification take effect",
  "搜索": "search",
  "所有读写经过 Go Control Plane 的领域规则与事务。": "All reads and writes go through the domain rules and transactions of the Go Control Plane.",
  "所有现有 Access Token 和 Refresh Token 将立即失效，玩家需要重新登录。": "All existing Access Tokens and Refresh Tokens will immediately expire and players will need to log in again.",
  "踢出": "kick out",
  "提供商": "provider",
  "添加文件": "Add files",
  "条": "strip",
  "停用": "deactivate",
  "停用后新注册无法使用，但可由有权限的管理员重新启用。": "New registrations cannot be used after deactivation, but can be re-enabled by a qualified administrator.",
  "通过": "pass",
  "玩家": "player",
  "玩家 ID": "Player ID",
  "玩家管理": "player management",
  "玩家会话已撤销。": "Player session revoked.",
  "玩家将立即获得当前配置的 VIP 权益。": "Players will immediately receive the currently configured VIP benefits.",
  "玩家将失去 VIP 权益。": "Players will lose VIP benefits.",
  "玩家与会话": "Players and Sessions",
  "玩家账号已封禁。": "The player account has been banned.",
  "玩家账号已封禁并撤销全部会话。": "The player's account has been banned and all sessions have been revoked.",
  "玩家账号已恢复。": "Player account has been restored.",
  "维护模式停止接收新任务；停用会撤销服务器注册凭据。页面不提供任意 Shell 命令。": "Maintenance mode stops accepting new tasks; deactivation revokes server registration credentials. The page does not provide any shell commands.",
  "维护期限（秒）": "Maintenance period (seconds)",
  "未关联": "Not associated",
  "未命名玩家": "Unnamed player",
  "未知来源地址": "Unknown source address",
  "未知浏览器": "Unknown browser",
  "未知账号": "Unknown account",
  "未执行": "Not executed",
  "文件": "document",
  "文件与 Manifest": "Files and Manifest",
  "我的管理员会话": "my admin session",
  "我的会话": "my session",
  "我已安全保存": "I have saved it safely",
  "无法登录？请通过内部值班渠道联系平台管理员，不要发送密码、验证码或 Token。": "Can't log in? Please contact the platform administrator through internal duty channels and do not send passwords, verification codes or tokens.",
  "无法读取管理员登录配置。": "Unable to read administrator login configuration.",
  "无法读取管理员会话。": "Unable to read administrator session.",
  "无法读取玩家详情": "Unable to read player details",
  "无法读取运营指标。": "Unable to read operational metrics.",
  "无数据库直连": "No direct database connection",
  "系统设置": "System settings",
  "系统设置请求失败。": "System settings request failed.",
  "系统设置已更新并写入审计日志。": "System settings are updated and written to the audit log.",
  "系统设置与集成": "System setup and integration",
  "系统先创建 DRAFT；必须通过 Manifest、签名、SHA-256、路径和版本兼容校验成为 READY，之后再经二次 MFA 正式发布。": "The system first creates DRAFT; it must pass Manifest, signature, SHA-256, path and version compatibility verification to become READY, and then be officially released through the second MFA.",
  "下一步": "Next step",
  "下载": "download",
  "下载 CSV": "Download CSV",
  "显示名": "display name",
  "详情": "Details",
  "项 · 查看对应资源": "Item · View corresponding resources",
  "项非秘密配置，并立即写入审计日志。": "The configuration is non-secret and written to the audit log immediately.",
  "项权限": "item permissions",
  "校验": "check",
  "协商中": "Under negotiation",
  "写操作和登录结果由后端记录，敏感 Token 自动排除。": "Write operations and login results are recorded by the backend, and sensitive tokens are automatically excluded.",
  "新建版本": "New version",
  "新建管理员": "Create new administrator",
  "新建客户端发布": "New client release",
  "修改后": "After modification",
  "修改前": "Before modification",
  "修改原因": "Reason for modification",
  "选择已上传到对象存储的文件": "Select a file uploaded to object storage",
  "压缩": "compression",
  "严重度": "Severity",
  "验证并进入控制台": "Verify and enter the console",
  "验证动态验证码": "Verify dynamic verification code",
  "邀请码": "Invitation code",
  "邀请码配置已更新。": "Invitation code configuration has been updated.",
  "邀请码已撤销，不能再次启用。": "The invitation code has been revoked and cannot be activated again.",
  "邀请码已生成": "Invitation code has been generated",
  "邀请码已停用。": "Invitation code has been disabled.",
  "邀请码已重新启用。": "Invitation code has been reactivated.",
  "一次性 MFA 配置": "One-time MFA configuration",
  "一次性 MFA 配置已复制到剪贴板。": "The one-time MFA configuration has been copied to the clipboard.",
  "一次性恢复码": "one-time recovery code",
  "移出房间？": "Move out of the room?",
  "移除": "Remove",
  "已撤销": "Revoked",
  "已处理": "Processed",
  "已封禁": "Banned",
  "已复制全部邀请码。": "All invitation codes have been copied.",
  "已过期": "Expired",
  "已接入": "Already connected",
  "已启用": "Enabled",
  "已认证": "Certified",
  "已删除": "Deleted",
  "已失效": "Expired",
  "已停用": "Deactivated",
  "已用尽": "exhausted",
  "异常": "abnormal",
  "英文": "English",
  "用户。": "user.",
  "由 Cloudflare 提供": "Powered by Cloudflare",
  "有效": "efficient",
  "有效期（留空清除）": "Validity period (leave blank to clear)",
  "有效期（留空为长期）": "Validity period (leave blank for long term)",
  "有效期至": "Valid until",
  "语言": "language",
  "语言：中文": "Language: Chinese",
  "预览": "Preview",
  "原 TOTP、恢复码和全部登录会话将立即失效；新配置只显示一次。": "The original TOTP, recovery codes, and all login sessions will be immediately invalid; the new configuration will only be displayed once.",
  "原因": "reason",
  "允许 P2P 联机": "Allow P2P connections",
  "允许创建账号": "Allow account creation",
  "运营备注": "Operational notes",
  "运营趋势": "Operational trends",
  "运营指标暂时不可用": "Operational metrics are temporarily unavailable",
  "运营总览": "Operations Overview",
  "在当前结果中搜索玩家 ID、SteamID 或名称": "Search for player ID, SteamID or name in current results",
  "在线 Dedicated Server": "Online Dedicated Server",
  "暂无管理员账号。": "There is currently no administrator account.",
  "暂无迁移记录。": "There is no migration record yet.",
  "暂无使用记录。": "There is no usage record yet.",
  "展开导航": "Expand navigation",
  "长期有效": "Effective for a long time",
  "账号将恢复登录和使用权限。": "The account will have its login and usage rights restored.",
  "账号将无法继续使用；可同时撤销全部会话以立即下线。": "The account will no longer be available; all sessions can be revoked at the same time to log you offline immediately.",
  "账号密码已确认，请完成动态验证码验证。": "The account password has been confirmed, please complete the dynamic verification code verification.",
  "账号验证": "Account verification",
  "账号状态与会话操作会由控制面写入审计日志。前端权限仅用于改善体验，后端仍会再次校验。": "Account status and session operations will be written to the audit log by the control plane. Front-end permissions are only used to improve the experience, and the back-end will still verify it again.",
  "账号资料": "Account information",
  "这不会自动封禁玩家或撤销会话。处理人、时间和原因会写入操作审计。": "This does not automatically ban the player or revoke the session. Who, when, and why are written into the operational audit.",
  "这里只提供经过后端白名单验证的非秘密配置，不展示数据库、Redis、Token、密钥或私钥。": "Only non-secret configurations verified by the backend whitelist are provided here. Databases, Redis, Tokens, keys or private keys are not displayed.",
  "这是当前会话，撤销后需要重新登录。": "This is the current session and you will need to log in again after revoking it.",
  "这些明文邀请码只显示本次": "These clear text invitation codes are only displayed this time",
  "正常": "normal",
  "正式发布": "Officially released",
  "正在加载安全配置…": "Loading security configuration...",
  "证书到期": "Certificate expires",
  "支持": "support",
  "只读运维集成": "Read-only operation and maintenance integration",
  "至少添加一个文件。": "Add at least one file.",
  "中继节点": "relay node",
  "中继节点身份已撤销。": "The relay node identity has been revoked.",
  "中继节点已恢复接收连接。": "The relay node has resumed receiving connections.",
  "中继节点已进入维护模式。": "The relay node has entered maintenance mode.",
  "中文": "Chinese",
  "重置": "reset",
  "重置 MFA": "Reset MFA",
  "重置 MFA ·": "Reset MFA ·",
  "重置并撤销会话": "Reset and revoke session",
  "注册时间": "Registration time",
  "专服": "dedicated server",
  "专服将标记 OFFLINE，注册 Token 被撤销；恢复需要重新注册。": "The dedicated server will be marked OFFLINE, and the registration token will be revoked; recovery requires re-registration.",
  "专服将恢复为 READY 并可再次接收任务。": "The dedicated server will be restored to READY and can receive tasks again.",
  "专服将停止接收新任务，现有会话不会由此按钮强制终止。": "The dedicated server will stop accepting new tasks, and existing sessions will not be forcibly terminated by this button.",
  "专服已恢复接入。": "Access to the dedicated server has been restored.",
  "专服已进入维护模式。": "The dedicated server has entered maintenance mode.",
  "专服已停用并撤销注册凭据。": "The dedicated server has been deactivated and the registration credentials have been revoked.",
  "状态": "state",
  "资源类型": "Resource type",
  "资源数": "Number of resources",
  "最大次数": "Maximum times",
  "最大批量数": "Maximum batch size",
  "最大使用次数": "Maximum number of uses",
  "最低兼容": "Minimum compatible",
  "最低兼容版本": "Minimum compatible version",
  "最后登录": "last login",
  "最后心跳": "last heartbeat",
  "最近活动": "Recent activities",
  "最近使用": "Recently used",
  "最小权限": "least privilege",
  "Access Token 仅保存在内存，Refresh Cookie 每次轮换。": "The Access Token is only stored in memory, and the Refresh Cookie is rotated each time.",
  "ACTIVE · 可登录": "ACTIVE · Can log in",
  "API 版本": "API version",
  "API 能力发现": "API capability discovery",
  "Connection 将进入 CLOSED，活动 Relay Allocation 会被撤销；此操作不能从页面恢复。": "The Connection will go CLOSED and the active Relay Allocation will be revoked; this operation cannot be restored from the page.",
  "Connection 已关闭，但 Relay 清理尚未确认，请按 Runbook 复核。": "Connection is closed, but Relay cleanup has not been confirmed, please press the runbook to review.",
  "Connection 已关闭，Relay Allocation 已清理。": "Connection closed, Relay Allocation cleaned.",
  "Dashboard 轮询": "Dashboard polling",
  "DISABLED · 禁止登录并撤销会话": "DISABLED · Disable login and revoke session",
  "DRAFT → READY → PUBLISHED。正式发布与回滚均要求二次 MFA，Manifest 使用 Ed25519 签名。": "DRAFT → READY → PUBLISHED. Both formal release and rollback require secondary MFA, and the Manifest is signed with Ed25519.",
  "DRAFT 发布版本已创建，请执行发布前校验。": "DRAFT release version has been created, please perform pre-release verification.",
  "Fleet 轮询": "Fleet polling",
  "IP 摘要": "IP summary",
  "MFA 提权凭证只保存在当前浏览器内存中，并绑定当前 Session。": "MFA privilege escalation credentials are only saved in the current browser memory and bound to the current Session.",
  "MFA 已重置，原有管理员会话均已撤销。": "MFA has been reset and all previous admin sessions have been revoked.",
  "P2P 房间": "P2P room",
  "ProjectRebound 管理控制台": "ProjectRebound Management Console",
  "RBAC 权限与后端审计": "RBAC permissions and backend auditing",
  "READY 中继节点": "READY relay node",
  "Refresh Token 不会显示在此页面。撤销当前会话后需要重新完成 Turnstile、密码和 TOTP 登录。": "Refresh Token will not be displayed on this page. Turnstile, password, and TOTP logins will need to be redone after revoking the current session.",
  "Relay 节点 ID": "Relay node ID",
  "Relay 迁移记录": "Relay migration record",
  "Siteverify 延迟": "Siteverify delays",
  "SUPER_ADMIN 始终拥有全部权限且不可修改，避免出现权限目录与实际授权漂移。": "SUPER_ADMIN always has full permissions and cannot be modified to avoid drift between the permission directory and actual authorization.",
  "TOTP 或恢复码": "TOTP or recovery code",
  "Turnstile 服务端 Siteverify": "Turnstile server Siteverify",
  "VIP 已启用。": "VIP is enabled.",
  "VIP 已取消。": "VIP has been cancelled.",
  "VPN / 零信任访问代理": "VPN / Zero Trust Access Proxy",
};
